export default {
  open_standalone: 'Geöffnet',
  closed_standalone: 'Geschlossen',

  open: 'Geöffnet',
  closed: 'Geschlossen',
  opening: 'Wir öffnen',
  closing: 'Schließt',
  yes_we_are: 'Wir haben',
  sorry_we_are: 'Wir haben',
  twentyfourseven: 'Durchgehend',
  closing_tomorrow: 'Schließt morgen',
  opening_tomorrow: 'Öffnet morgen',
  at_x: 'um %x%',
  closing_x: 'Schließt %x%',
  opening_x: 'Öffnet %x%',

  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',

  businessHours: 'Öffnungszeiten'
};



// WEBPACK FOOTER //
// ./src/commons/translations/de.js